module.exports = __webpack_public_path__ + "media/1x1/gn-1ce64523.svg";